import * as React from 'react';

function SvgPeaceFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M14 13.292A8 8 0 008.5.015v7.778l5.5 5.5zm-.708.708L8.5 9.206v6.778a7.967 7.967 0 004.792-1.986zM7.5 15.985V9.207L2.708 14A7.967 7.967 0 007.5 15.985zM2 13.292A8 8 0 017.5.015v7.778l-5.5 5.5z' />
		</svg>
	);
}

export default SvgPeaceFill;
